import * as types from './types';
import * as _ from 'lodash';

const INITIAL_STATE = {
  vendorSetup: {
    Data: [],
    Errors: [],
  },
  isGridLoading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.VENDORSETUP_GRID_LOADING:
      return {
        ...state,
        isGridLoading: action.payload,
      };
    case types.VENDORSETUP_GET:
      return {
        ...state,
        vendorSetup: {
          ...state.vendorSetup,
          Data: action.payload.data.Data,
        },
      };
    case types.VENDORSETUP_GET_ERROR:
      if (_.has(action.payload, 'response.data.Error')) {
        return {
          ...state,
          vendorSetup: {
            Errors: action.payload.data.Errors,
          },
        };
      } else {
        return {
          ...state,
          vendorSetup: {
            Errors: [
              {
                Title: 'Error',
                Message:
                  'An error occurred while fetching distributors. Please try again',
              },
            ],
          },
        };
      }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/state/page/reducer.js